import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
} from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TrackInteractionDirective } from '@analytics/events';
import { PartialAccordionTitleComponent } from '@legacy/common-ui-partials';

import { IAccordion } from './accordion.model';
import type { IAccordionItems } from './accordionItems.model';
import { RichTextWrapperComponent } from '../rich-text-wrapper/rich-text-wrapper.component';

@Component({
  selector: 'wl-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: [
    './accordion.component.ed.scss',
    './accordion.component.essent.scss',
  ],
  host: { ngSkipHydration: 'true' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgbAccordionDirective,
    NgClass,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    TrackInteractionDirective,
    NgbAccordionCollapse,
    NgbAccordionBody,
    RichTextWrapperComponent,
    PartialAccordionTitleComponent,
  ],
})
export class AccordionComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() accordions?: IAccordion;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() pageTitle?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableTransparancy = true;

  trackById(_: number, item: IAccordionItems): string {
    return item.id;
  }

  getClickData(item: IAccordionItems) {
    return {
      subject: `faq|${this.pageTitle || ''}`,
      name: (item.question && item.question.value) || '',
    };
  }
}
